<ng-container *transloco="let t; prefix: 'experience'">
  <div [mat-dialog-close]="true" class="modal-backdrop"></div>
  <div class="self-explore-container modal-container" id="self-explore-modal">
    <button aria-label="{{ t('close') }}" class="close" mat-dialog-close type="button">
      <mat-icon>close</mat-icon>
    </button>
    <section #map (click)="closeCard()" (keyup.enter)="closeCard()" class="map" tabindex="0"></section>
    <section #overlay [ngClass]="{active: selectedExperienceId !== null}" class="related-experiences">
      @for (relatedExperience of relatedExperiences; track relatedExperience; let i = $index) {
        <div
          class="related-experience"
          [ngClass]="{active: relatedExperience.id === selectedExperienceId}"
          (touchstart)="onTouchStart($event)"
          (touchend)="onTouchEnd($event, relatedExperience)"
          (mousedown)="onTouchStart($event)"
          (mouseup)="onTouchEnd($event, relatedExperience)"
        >
          <div class="header">
            <figure>
              <img
                alt="{{ t('imageTitle', {title: relatedExperience.title}) }}"
                src="{{ relatedExperience.image | resizeImg: 90 : 90 }}"
              />
            </figure>
            <section>
              <div class="num">
                <img
                  alt="{{ t('imageNumber', {imageNumber: i + 1}) }}"
                  src="{{ NUMBER_URL }}{{ i + 1 | number: '2.0' }}.svg"
                />
              </div>
              <div class="content">
                <h2 class="heading-s">{{ relatedExperience.subcategory.toUpperCase() }}</h2>
                <h3 class="heading-xl">{{ relatedExperience.title }}</h3>
              </div>
            </section>
          </div>
          @if (relatedExperience.id === selectedExperienceId) {
            <div>
              @if (expandedExperience$ | async; as expandedExperience) {
                <ess-experience-modal-card [experience]="expandedExperience" />
              } @else {
                <ess-load />
              }
            </div>
          }
        </div>
      }
    </section>
  </div>
</ng-container>
